// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__E5b7g","content":"modal_content__yiwHu"};